import React from 'react';
import { Observable, forkJoin } from 'rxjs';

import { Set, Map, List, fromJS } from 'immutable';
import { createAjax } from 'trustar/utils/redux-utils';

export const useAjax = (effectCb, shouldCall = true) => {
  const [response, setResponse] = React.useState(Map());
  const [errorResponse, setErrorResponse] = React.useState(Map());
  const [isLoading, setIsLoading] = React.useState(false);

  const ajax = createAjax();

  // $FlowFixMe: React.useEffect coming soon.
  const executeRequest = () => {
    setIsLoading(true);
    setResponse(Map());

    if (!shouldCall) {
      setIsLoading(false);
      return;
    }

    const rxSubscription = effectCb(ajax).subscribe({
      complete: x => {
        setIsLoading(false);
      },
      next: x => {
        setIsLoading(false);
        const responseBodyOrFullResponse = x.response || x;
        setResponse(fromJS(responseBodyOrFullResponse));
      },
      error: err => {
        setIsLoading(false);
        setErrorResponse(fromJS(err));
      }
    });

    return function cleanup() {
      rxSubscription.unsubscribe();
    };
  };

  return Map({
    executeRequest,
    response,
    errorResponse,
    isLoading
  });
};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/hooks/useAjax.js